import './styles.scss';
import ProductItem from './ProductItem';

const ProductItems = ({ data }) => (
    <div className="product-items">
        {data?.map(product => (
            <ProductItem key={product.slug} product={product} />
        ))}
    </div>
);

export default ProductItems;
